// Utility for emitting Pusher events from ParkProUI
// This will be called after successful itinerary updates

export const emitItineraryUpdate = async (tripId, updateData) => {
  try {
    const apiUrl = import.meta.env.VITE_API_URL;
    if (!apiUrl) {
      console.error('VITE_API_URL is not set, cannot emit Pusher event');
      return;
    }
    
    // Call backend endpoint to emit Pusher event
    const response = await fetch(`${apiUrl}/api/pusher/emit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        channel: `trip-${tripId}`,
        event: 'itinerary-updated',
        data: {
          tripId,
          dayIndex: updateData.dayIndex,
          section: updateData.section,
          content: updateData.content,
          updatedAt: new Date().toISOString(),
          updatedBy: 'agent',
          editNotes: updateData.editNotes
        }
      })
    });

    if (!response.ok) {
      console.error('Failed to emit Pusher event:', response.status);
    }
  } catch (error) {
    console.error('Error emitting Pusher event:', error);
  }
};

export const emitTripRename = async (tripId, newName) => {
  try {
    const apiUrl = import.meta.env.VITE_API_URL;
    if (!apiUrl) {
      console.error('VITE_API_URL is not set, cannot emit Pusher event');
      return;
    }
    
    const response = await fetch(`${apiUrl}/api/pusher/emit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        channel: `trip-${tripId}`,
        event: 'trip-renamed',
        data: {
          tripId,
          newName,
          updatedAt: new Date().toISOString()
        }
      })
    });

    if (!response.ok) {
      console.error('Failed to emit trip rename event:', response.status);
    }
  } catch (error) {
    console.error('Error emitting trip rename event:', error);
  }
};
